import styled from 'styled-components';

export const CompactSignUpWrapper = styled.div(({ theme }) => ({
  alignSelf: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  paddingLeft: theme.spacing.xlarge,
  paddingRight: theme.spacing.xlarge,
}));

export const FormWrapper = styled.form(({ theme }) => ({
  alignSelf: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  paddingTop: theme.spacing.default,
  paddingBottom: theme.spacing.default,
}));

export const SignUpButtonWrapper = styled.div({
  alignSelf: 'center',
  marginBottom: '15px',
  marginTop: '10px',
});
